import { ColDef, ColGroupDef } from '@ag-grid-community/core';

import { TableConstants } from '@shared/constants/table.constants';

import { getCostColumns } from './site-cost-summary-table-cost-config';
import { SiteSummaryGridContext } from '../types/site-summary-grid-context';
import { SiteSummaryGridRow } from '../types/site-summary-grid-row';

const NO_DEFINED_FREQUENCY = 'No Defined Frequency';

const frequencies = [
  'Activation',
  'Annually',
  'Closeout',
  'Monthly',
  'Quarterly',
  'No Defined Frequency',
] as const;

export const siteCostSummaryTableSiteInvoiceablesConfig = (
  ctx: SiteSummaryGridContext
): ColGroupDef<SiteSummaryGridRow> => {
  return {
    children: getFrequencyColumns(ctx),
    headerClass: [TableConstants.STYLE_CLASSES.HEADER_ALIGN_CENTER, 'text-center', 'text-wrap'],
    headerName: 'Frequency',
  };
};

export const getFrequencyColumns = (ctx: SiteSummaryGridContext): ColDef<SiteSummaryGridRow>[] => {
  return frequencies.map((frequency) => ({
    ...getCostColumns(ctx, 'frequencies', frequency),
    headerClass: 'ag-gray-header',
    headerName: frequency === NO_DEFINED_FREQUENCY ? 'Uncategorized' : frequency,
  }));
};
